const Titles = {
    "WELLCOME_TO_THE" : "Қош келдіңіз",
    "LOGIN" : "ЛОГИН",
    "PASSWORD" : "ҚҰПИЯ СӨЗ",
    "DON'T_REMEMBER_PASSWORD" : "ҚҰПИЯ СӨЗ ЕСІМДЕ ЖОҚ",
    "ENTER": "Кіру",
    "REQUEST": "Сұраныс жіберу",
    "SIGN_IN" : "Жүйеге кіру",
    "EMAIL_OR_LOGIN" : "ЭЛЕКТРОНДЫҚ ПОШТАНЫҢ АДРЕСІ НЕМЕСЕ ЛОГИН",
    "CONTINUE" : "Жалғастыру",
    "ABOUT_PRODUCT": "Өнім туралы",
    "SITUABLE_FOR": "Кімге арналған",
    "HOW_WORKS": "Қалай жұмыс істейді",
    "ADVANTAGES": "Артықшылықтары",
    "CONTACTS": "Байланыс",
    "TELEGRAM": "Телеграм",
    "LANGUAGES": "Тілдер",
    "INFO_SOURCE": "Ақпарат көздері",
    "MEDIA_COUNT": "БАҚ саны",
    "KZ_COUNT": "Оның ішінде қазақстандық",
    "SOCIAL_COUNT": "Әлеуметтік желілердегі парақшалар",
    "GET_MORE": "Көбірек білу",
    "NAME": "Аты",
    "PHONE": "Телефон нөмеріңіз",
    "FIELD_NOT_BE_EMPTY": "Өріс бос болмауы керек",
    "PASSWORD_RESTORE" : "Құпия сөзді қалпына келтіру",
    "ONLY_NUMBERS_AND_LETTERS_AT_LEAST_3": "Тек әріптер мен сандар, кемінде 3 таңба",
    "ONLY_NUMBERS_AND_LETTERS": "Тек әріптер мен сандар",
    "ONLY_LETTERS": "Только буквы",
    "A_LETTER_WITH_INSTRUCTIONS_WAS_SENT_TO_YOUR_EMAIL_ADDRESS" : "НҰСҚАУЛЫҚТАРЫ БАР ХАТ СІЗДІҢ ЭЛЕКТРОНДЫҚ ПОШТА МЕКЕН-ЖАЙЫҢЫЗҒА ЖІБЕРІЛДІ",
    "SORRY_SUCH_MAIL_OR_LOGIN_IS_NOT_REGISTERED" : "ӨКІНІШКЕ ОРАЙ БҰНДАЙ ПОШТА НЕМЕСЕ ЛОГИН ТІРКЕЛМЕГЕН",
    "TRY_AGAIN" : "Тағы бір рет көру",
    "CANCEL" : "Бас тарту",
    "OBLIGATORY_FIELD": "Міндетті өріс",
    "ONLY_NUMBER": "Телефон нөмірі қате енгізілді",
    "TOPICS_FOR_MONITORING": "Мониторинг тақырыптары (кілт сөздер)",
    "DEMONSTRATION_PRODUCT": "Өнімді көрсету",
    "GET_DEMO_LICENSE": "“Демо-нұсқаны алу” батырмасын баса отырып, сіз ",
    "GET_DEMO_LICENSE_POLICY": " құпиялық саясатының ",
    "GET_DEMO_LICENSE_2": "шарттарымен келісесіз және жеке деректерді өңдеуге рұқсат бересіз",
    "GET_DEMO_SUCCESS": "Демонстрациялық қатынасты қамтамасыз ету сұрауы сәтті жіберілді.",
    "EMAIL_ADDRESS" : "Сіздің электрондық поштаңыз  (формат: login@example.com)",
    "NOT_VALID_EMAIL" : "ЖАРАМСЫЗ ЭЛЕКТРОНДЫ АДРЕС",
    "NEW_REVIEW_ON_MAP": "Онлайн картада жаңа шолу",
    "GOOD_SERVICE": "Жақсы қызмет, мен ұсынамын",
    "YOU_WERE_MENTIONED_IN_COMMENT": "Сізді пікірде атап өтті",
    "USER_MENTIONED_YOU": "@karina8800 пайдаланушысы сізді пікірде атап өтті",
    "YOU_MENTIONED_ON_MEDIA": "СІЗ 1 БАҚ-та АЙТЫЛДЫ",

    "CLOSE": "Жабу",
    "MONITORING": "мониторингі",
    "MEDIA_SOCIAL_BLOGS": "БАҚ, әлеуметтік желілер, блогтар ",
    "REVIEWS_ON": "пікірлер,",
    "ONLINE_MAPS": " онлайн-карталардағы ",
    "TRACK_MEMORIES": "Аталымдарды қадағалаңыз, трендтерді талдаңыз, тәуекелдерді болжаңыз!",
    "MONITORING_FAVOURITVE_SOCIAL": "Танымал әлеуметтік желілер мен БАҚ (соның ішінде 5000 қазақстандық), сонымен қатар, онлайн карталардағы пікірлер мониторингі",
    "GET_DEMO_ACCESS": "Демо-нұсқаны алу",
    "WANT_DEMO_ACCESS": "Мен Демо-нұсқаны қол жеткізгім келеді",
    "KEYWORDS": "Кілттік сөздер",
    "TOPICS_AND_KEYWORDS": "Тақырыптар және кілт сөздер",
    "KEYWORDS_DESCRIPTION": "Жүйе автоматты түрде мәтінінде немесе тақырыбында кем дегенде бір кілт сөз кездесетін жарияланымдарды жинайды ",
    "KEYWORDS_TEXT": "<ul><li>Кілт сөздерді сіз енгізесіз — бұл терминдер, фразалар немесе сөз тіркестері болуы мүмкін.</li> <li> Барлық ақпарат ыңғайлы лентада көрсетіледі, бұл қажетті аталымдарды талдау және қадағалауды жеңілдетеді</li> </ul> Баптаулар икемділігі сәйкес деректерді жылдам табуға және ақпарат ағындарын тиімді басқаруға мүмкіндік береді",

    "BIG_DATA": "Ауқымды деректер",
    "MEDIA": "БАҚ",
    "REVIEWS_FROM_MAPS": "Пікірлер",
    "SOCIAL": "Әлеуметтік желілер",
    "MENTIONS": "Аталымдар",
    "KEY_WORDS": "Кілт сөздер",

    "BE_FIRST_TO_KNOW": " бірінші болып біліңіз",
    "WHO_WROTE_ABOUT": "БАҚ пен әлеуметтік желілердегі жарияланымдарда сіз туралы кім жазғанын",
    "MONITOR_THE_REPUTATION": "беделін кез келген ақпараттық өрісте бақылаңыз",
    "COMPANIES_BRANDS_TOP_MANAGMENT": "Компанияның, брендтің немесе ТОП-менеджменттің ",
    "MEDIA_SOCIAL_TELEGRAM": ": БАҚ, әлеуметтік желілер, телеграм-каналдар және онлайн-карталардағы пікірлер",
    "GET_VALUABLE_INSIGHTS_BOLD": "Серіктестеріңіз, клиенттеріңіз немесе бәсекелестеріңіз туралы",
    "GET_VALUABLE_INSIGHTS": " құнды ақпаратты",
    "IN_REALTIME": " нақты уақыт режимінде тікелей Telegram немесе электрондық поштаға алыңыз",

    "A_TOOL_FOR_STRATEGIC": " Саясат, бизнес, медиа және ғылым салаларында стратегиялық басқаруға арналған құрал. Тәуекелдер мен мүмкіндіктерді алдын ала анықтауға, беделді бақылауға, бәсекелестерді қадағалауға және тиімді PR науқандары үшін ақпарат ағындарын басқаруға мүмкіндік береді.",

    "TOPIC_COMPARISON": "Тақырыптарды салыстыру",
    "TOPIC_COMPARISON_DESCRIPTION": "Жүйе әртүрлі ақпарат ағындарын салыстыруға, заңдылықтарды анықтауға және аталымдардағы өзгерістерді талдауға мүмкіндік береді.",
    "TOPIC_COMPARISON_TEXT": "<ul><li>Салыстыру үшін бірнеше тақырыпты таңдаңыз.</li> <li>Жүйе оларды негізгі метрикалар бойынша талдайды: аталымдар саны, тоналдық, таралу динамикасы.</li> <li>Деректердің визуализациясы трендтерді анықтауға, қай тақырыптардың өзектілігі артып жатқанын немесе керісінше, төмендеп жатқанын көруге көмектеседі.</li> <li>PR-мақсаттарды шешу үшін бәсекелестердің белсенділігін салыстырыңыз.</li></ul> Бұл құрал ақпараттық оқиғалардың ықпалын жедел бағалауға және әрекет ету стратегияларын нақтылауға көмектеседі.",

    "SAMPLE": "Іріктеме",
    "SAMPLE_DESCRIPTION": "Жүйе релевантты жарияланымдарды икемді сүзгілер мен сұрыптау мүмкіндіктері бар ыңғайлы лентада  жылдам табуға көмектеседі.",
    "SAMPLE_TEXT": "<ul><li>Уақыт, дереккөздер, тоналдық және кілт сөздер бойынша кеңейтілген сүзгілерді пайдаланыңыз.</li> <li>Жүйе берілген критерийлерге сәйкес келетін аталымдар тізімін лезде қалыптастырады.</li> <li>Ақпараттық шудан аулақ болып, тек сәйкес деректерді таңдаңыз.</li> </ul>Бұл құрал деректерді жедел талдауға, трендтерді бақылауға және негізделген шешімдер қабылдауға мүмкіндік береді., отслеживать тренды и принимать обоснованные решения.",

    "EXTENDED_ANALYTIC": "Кеңейтілген талдау",
    "EXTENDED_ANALYTIC_DESCRIPTION": "Жүйе ақпараттық өрісті терең талдауға арналған интерактивті дашбордтарды ұсынады.",
    "EXTENDED_ANALYTIC_TEXT": "<ul><li> Уақыт, дереккөздер, тоналдық және негізгі метрикалар бойынша икемді сүзгілерді қолданып, деректерді талдаңыз.</li> <li>Трендтер динамикасын және аудиториялық инсайттарды қадағалаңыз.</li><li> Деректерді ыңғайлы форматта визуализациялау заңдылықтарды тез анықтауға және негізделген шешімдер қабылдауға көмектеседі.</li></ul> Бұл құрал құнды инсайттар алуға, өзгерістерді болжауға және стратегияларды нақты уақыт режимінде түзетуге мүмкіндік береді.",

    "REPORTS": "Есептер",
    "REPORTS_DESCRIPTION": "Жүйе бірнеше рет басу арқылы егжей-тегжейлі талдау есептерін жедел жасауға мүмкіндік береді.",
    "REPORTS_TEXT": "<ul><li>Терең талдау үшін таңдалған параметрлер бойынша есептер жасаңыз.</li> <li>Деректерді ыңғайлы форматта экспорттаңыз (PDF, Excel, Word, JSON).</li> <li>Есептерді мүдделі тараптарға автоматты түрде жіберуді баптаңыз.</li></ul> Бұл құрал деректермен жұмысты жеңілдетеді, талдауды жедел бөлісуге және стратегиялық шешімдер қабылдауға көмектеседі.",
    
    "DASHBOARDS": "Дашбордтар",
    "DASHBOARDS_DESCRIPTION": "Жүйе жағдайды жылдам бағалауға мүмкіндік береді, қысқа және ақпараттылық көрсеткіштерді береді.",
    "DASHBOARDS_TEXT": "<ul><li>Барлық негізгі ақпарат бір бетте берілген.</li> <li>Терең талдауды қажет етпестен негізгі көрсеткіштер мен трендтерді қадағалаңыз.</li> <li>Жылдам шешім қабылдау үшін жылдам түсінік алыңыз.</li></ul> Бұл құрал оқиғалар динамикасын лезде бағалауға және өзгерістерге жылдам жауап беруге көмектеседі",

    "NOTIFICATIONS": "Хабарламалар",
    "NOTIFICATIONS_DESCRIPTION": "Жүйе медиакеңістіктегі маңызды өзгерістер туралы жедел хабарламалар алуға мүмкіндік береді.",
    "NOTIFICATIONS_TEXT": "<ul><li>Telegram және электронды пошта арқылы хабарламалар алыңыз.</li><li>Жаңа жарияланымдарды, трендтер мен маңызды өзгерістерді нақты уақыт режимінде бақылаңыз.</li><li>Жағдайды бақылауда ұстау және тәуекелдерді азайту үшін жедел әрекет етіңіз.</li></ul> Бұл құрал әрдайым бір қадам алда болуға және негізделген шешімдерді жылдам қабылдауға көмектеседі",
    
    "MEDIAMONITORING": "медиамониторинг",
    "IN_ONLINE": "нақты уақыт режиміндегі",
    "MEDIAMONITORING_DESCRIPTION_TEXT": "Ақпараттық өріске толық шолу: жарияланымдар, трендтер мен пікірлерді талдау",
    "SOCIAL_MONITORING": " БАҚ, әлеуметтік желілер, карталардағы пікірлер мониторингі",
    "LIVE_TRACKING": "Жаңалықтар мен аталымдарды нақты уақыт режимінде жедел қадағалау",
    "REPUTATION_ANALYSIS": "Компаниялар, басшылар және салалардың беделдік қауіп-қатерлерін талдау",
    "HISTORICAL_ANALYSIS": "Тарихи талдау және ұзақ мерзімді трендтер",
    "CONTENT_ANALYSIS": "Қазақ тіліндегі контентті талдау",
    "WRITERS_RATING": "Сіз туралы жазатын ықпалды БАҚ пен авторлардың рейтингі және тоналдықтыталдау",

    "CONVENIENT_FILTERING": "Берілген параметрлер бойынша ыңғайлы сүзгілеу",
    "NOTIFICATIONS_ONLNE": "Нақты уақыт режиміндегі хабарламалар",
    "STRUCTURED_SELECTION": "Құрылымдалған жаңалықтар топтамасы",
    "EXPORT_PUBLICATIONS": "Жиналған жарияланымдарды экспорттау",
    "USERS_NUMBER": "Кабинеттегі шектеусіз пайдаланушылар саны",
    "INTERCATIVE_DASHBOARDS": "Интерактивті дашбордтар мен есептер",
    "SAVING_FILTERS": "Сүзгілер мен баптауларды сақтау",

    "CONVENIENT_FILTERING_TEXT": "Интуитивті сүзгілер қажетті ақпаратты оңай табуға және іріктеме жасауға мүмкіндік береді",
    "NOTIFICATIONS_ONLNE_TEXT": "Жағымды және жағымсыз аталымдар туралы Telegram қосымшасына  хабарламалар алыңыз. Жылдам әрекет етіп, беделдік қауіп-қатерді азайтыңыз және брендке сенімді арттырыңыз",
    "ANALYTIC_TEXT": "Аталымдардың ауқымы мен динамикасын бағалаңыз, трендтерді анықтаңыз, жарияланымдардың тоналдығын талдаңыз және беделдік тақырыптардың дамуын болжаңыз.",
    "STRUCTURED_SELECTION_TEXT": "Жүйе берілген кілт сөздер мен тақырыптар бойынша соңғы жаңалықтарды автоматты түрде жинап, реттейді, қажетті жарияланымдарға жылдам қол жеткізуді қамтамасыз етеді.",
    "EXPORT_PUBLICATIONS_TEXT": "Экспорттау параметрлерінің икемділігі жұмысты жеңілдетеді — есептерді PDF, Word, Excel немесе JSON форматында небары бірнеше рет басу арқылы жүктеп алыңыз",
    "USERS_NUMBER_TEXT": "Аккаунтқа пайдаланушыларды шектеусіз қосып, қолжетімділікті оңай басқарыңыз",
    "INTERCATIVE_DASHBOARDS_TEXT": "Көрнекі талдау мен визуалды есептер деректерді талдауды жеңілдетіп, негізгі ақпаратты жылдам алуға мүмкіндік береді.",
    "SAVING_FILTERS_TEXT": "Жүйе сүзгілерді сақтауға және тақырыптық баптауларды бірнеше рет қолдануға мүмкіндік береді.",
    "ASK": "сұраңыз",
    "EXPERT": "Маманнан",
    "HAS_QUESTIONS": "Сұрақтарыңыз бар ма? Біздің мамандардан сұраңыз",
    "SCOPE_ACTIVITY": "Қызмет саласы",
    "TELEPHONE": "Телефон",
    "YOUR_QUESTION": "Сіздің сұрағыңызс",
    "ON_PRESSING_SUBMIT": "“Жіберу” батырмасын баса отырып, сіз ",
    "PRIVACY_POLICY_2": "Құпия саясаты ",
    "PRIVACY_POLICY": "құпиялық саясатының",
    "PROCESSING_PERSONAL_DATA": "шарттарымен келісесіз және жеке деректерді өңдеуге рұқсат бересіз.",
    "SUBMIT": "ЖІБЕРУ",
    "RETURN": "Қайту",
    "SEND_MESSAGE_SUCCESS": "Хабарлама сәтті жіберілді.",
    "OUR_PARTNERS": "Біздің серіктестер",

    "GOVERNMENT_BODIES": "Мемлекеттік органдар:",
    "GOVERNMENT_BODIES_DESCRIPTION": "Өкімет, әкімдіктер, комитеттер, басқармалар, қызметтер",
    "GOVERNMENT_BODIES_TEXT": "Қоғамдық пікір мен ақпарат ағындары мониторингі. Қоғам реакциясы мен мемлекеттік бастамалардың тиімділігін нақты уақыт режимінде бағалаңыз",
    
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS": "Саяси және қоғамдық ұйымдар:",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_DESCRIPTION": "Партиялар, ӨЕҰ, қоғамдық бірлестіктер",
    "POLITICAL_AND_PUBLIC_ORGANIZATIONS_TEXT": "Науқан тиімділігін талдау және жалған ақпаратпен күрес. Саяси және қоғамдық бастамалардың ықпалын бағалаңыз, фейктерді қадағалаңыз және беделіңізді қорғаңыз.",

    "BUSINESS_AND_FINANCE": "Бизнес және қаржы: ",
    "BUSINESS_AND_FINANCE_DESCRIPTION": "Компаниялар, банктер және қаржылық ұйымдар",
    "BUSINESS_AND_FINANCE_TEXT": "Беделді бақылау және нарықты талдау. Тәуекелдерді болжаңыз, инсайттарды анықтаңыз және негізгі нарықтық трендтерді қадағалаңыз.",

    "QUASI_PUBLIC_AND_PRIVATE_SECTOR": "Квази-мемлекеттік және жекеменшік сектор:",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_DESCRIPTION": " Компаниялар, ірі кәсіпорындар, жекеменшік мекемелер",
    "QUASI_PUBLIC_AND_PRIVATE_SECTOR_TEXT": "Беделді басқару және бәсекелестерді талдау. Нарықты талдаңыз, аталымдарды қадағалаңыз және тиімді PR-стратегияны құрыңыз.",

    "MEDIA_ANALYTICS_AND_PR": "Медиа, талдау және PR:",
    "MEDIA_ANALYTICS_AND_PR_DESCRIPTION": " БАҚ, PR-агенттіктер, ғылыми-зерттеу институттары, талдау орталықтар",
    "MEDIA_ANALYTICS_AND_PR_TEXT": "Терең талдау және трендтерді анықтау. Ақпарат ағындарын талдаңыз, кілт тақырыптарды қадағалаңыз және тиімді стратегиялар үшін инсайттар құрастырыңыз. ",
    "OFFERT": "Оферта",
    "TELEGRAM_BOT": "Telegram-бот",
    "FCBK": "Бірінші кредиттік бюро ЖШС",
    "RUS" : "Орыс",
    "KAZ" : "Қазақ",
    "ENG" : "English",
};

export default Titles;